import { render, staticRenderFns } from "./AverageStatusContact.vue?vue&type=template&id=48cb2be0&scoped=true&"
import script from "./AverageStatusContact.vue?vue&type=script&lang=js&"
export * from "./AverageStatusContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cb2be0",
  null
  
)

export default component.exports